import { useTranslation } from 'react-i18next';
import { locationInfo } from '@/mocks/accessData';

const LOCATION_COUNT = 5;

export default function LocationTable() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('access.location.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('access.location.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('access.location.titleEn')}
          </p>
          <div className="gold-line mx-auto"></div>
          <p className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[600px] mx-auto mt-5">
            {t('access.location.lead')}
          </p>
        </div>

        <div className="border border-background-200/60 bg-background-100/50">
          {/* Table header */}
          <div className="bg-primary-900 py-4 px-6">
            <p className="text-accent-400 text-[15px] tracking-[0.1em] font-medium text-center">
              {t('access.location.tableHeader')}
            </p>
          </div>

          {/* Table body */}
          <div className="divide-y divide-background-200/60">
            {Array.from({ length: LOCATION_COUNT }, (_, idx) => (
              <div
                key={idx}
                className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-8 py-5 px-6"
              >
                <span className="text-[14px] text-foreground-500 tracking-[0.06em] font-medium flex-shrink-0 sm:w-[100px] whitespace-nowrap">
                  {t(`access.location.${idx}.label`)}
                </span>
                <div>
                  {locationInfo[idx]?.link ? (
                    <a
                      href={locationInfo[idx].link}
                      className="text-[15px] text-foreground-800 tracking-[0.04em] hover:text-accent-600 transition-colors block"
                    >
                      {t(`access.location.${idx}.value`)}
                    </a>
                  ) : (
                    <p className="text-[15px] text-foreground-800 tracking-[0.04em]">
                      {t(`access.location.${idx}.value`)}
                    </p>
                  )}
                  {locationInfo[idx]?.note && (
                    <p className="text-[13px] text-foreground-400 tracking-[0.04em] mt-1">
                      {t(`access.location.${idx}.note`)}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
